import { takeLatest, put, call } from 'redux-saga/effects'
import * as constants from '../constants'
import * as actions from './actions'
import network from '../../utils/network'
import { getEndpointURL } from '../../utils/endpoint'
import GET_API_KEY from "../../utils/getApiKey"
function* handleGetUsers() {
    try {

        const API_KEY = GET_API_KEY()
        const action = getEndpointURL('STUDENTS')
        const params = {
            headers: {
                Authorization: 'Bearer ' + API_KEY,
            },
        }

        const { body } = yield call(network.getData, action, params)

        yield put(actions.getUsersSuccess(body))
    } catch (error) {
        if (error.message.indexOf("401") >= 0) {
            localStorage.clear()
            window.location.replace(process.env.REACT_APP_PAGE_BACKEND + 'login')
        }
        yield put(actions.getUsersError({ error }))
    }
}

export default function* () {
    yield takeLatest(constants.GET_USERS, handleGetUsers)
}
